// Dependencies
import { ThemeProvider } from "@mui/material";

// Components
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LayoutPage from "./pages/LayoutPage";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/ErrorFallback";
import NotiStackWrapper from "./components/Common/NotiStackWrapper";
import GlobalStyles from "./components/Common/GlobalStyles";
import LocalizationWrapper from "./components/Common/LocalizationWrapper";

// Routes
import { publicRoutes } from "./pages/routes/routes";

// Themes
import theme from "./components/Common/Theme";

// Styles
import { StylesProvider } from "@mui/styles";

function App() {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <NotiStackWrapper>
            <LocalizationWrapper>
              <Router>
                <div className="App">
                  <Routes>
                    {publicRoutes.map((route) => (
                      <Route
                        key={route.path}
                        path={route.path}
                        Component={route.component}
                      />
                    ))}
                    <Route path="/*" Component={LayoutPage} />
                  </Routes>
                </div>
              </Router>
            </LocalizationWrapper>
          </NotiStackWrapper>
        </ErrorBoundary>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
